export default "__VITE_ASSET__DCPMigrJ__"